import { z } from "zod";
import { FORM_VALIDATION } from "../constants";

export const loginSchema = z.object({
  email: z.string().min(1, "Email is required").email("Invalid email format"),
  password: z
    .string()
    .min(1, "Password is required")
    .min(
      FORM_VALIDATION.PASSWORD_MIN_LENGTH,
      `Password must be at least ${FORM_VALIDATION.PASSWORD_MIN_LENGTH} characters`
    ),
  instanceName: z
    .string()
    .optional()
    .refine((val) => !val || val.length >= 2, {
      message: "Instance name must be at least 2 characters",
    }),
  rememberMe: z.boolean(),
});

export const registerSchema = z
  .object({
    email: z.string().min(1, "Email is required").email("Invalid email format"),
    password: z
      .string()
      .min(1, "Password is required")
      .min(
        FORM_VALIDATION.PASSWORD_MIN_LENGTH,
        `Password must be at least ${FORM_VALIDATION.PASSWORD_MIN_LENGTH} characters`
      ),
    confirmPassword: z.string().min(1, "Please confirm your password"),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });
